import React, { useEffect, useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { getAcknowledgmentDocuments } from '../../../api'

import styles from './styles.module.scss'

const ChevronIcon = () => (
  <svg width="7" height="12" viewBox="0 0 7 12" fill="none">
    <path d="M1 1L6 6L1 11" stroke="#808F94" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const getDueDateLabel = (t, dueDate) => {
  if (!dueDate) return null
  const due = moment(dueDate)
  const diffDays = due.startOf('day').diff(moment().startOf('day'), 'days')
  let relative
  if (diffDays === 0) {
    relative = t('today')
  } else if (diffDays > 0) {
    relative = t('in {{count}} days', { count: diffDays })
  } else {
    relative = t('{{count}} days ago', { count: Math.abs(diffDays) })
  }
  return `${t('Due {{date}}', { date: due.format('MMM D, YYYY') })} · ${relative}`
}

const AcknowledgmentDocuments = () => {
  const { id: companyId } = useParams()
  const { t } = useTranslation()
  const history = useHistory()

  const [documents, setDocuments] = useState([])

  useEffect(() => {
    fetchDocuments()
  }, [companyId])

  const fetchDocuments = async () => {
    const res = await getAcknowledgmentDocuments(companyId)
    if (Array.isArray(res?.data)) {
      setDocuments(res.data)
    } else if (Array.isArray(res)) {
      setDocuments(res)
    }
  }

  const handleClickDocument = (doc) => () => {
    history.push({
      search: `?tab=required_reading&document_id=${doc.document_id}`
    })
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerInfo}>
          <div className={styles.headerTitle}>{t('Required reading')}</div>
          <div className={styles.headerDesc}>{t('Documents that many employees must read and acknowledge')}</div>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.grid}>
          {
            documents.map(doc => (
              <div key={doc.document_id} className={styles.card} onClick={handleClickDocument(doc)}>
                <div className={styles.cardHeader}>
                  <div>
                    <div className={styles.category}>{doc.category_name}</div>
                    <div className={styles.title}>{doc.document_name}</div>
                    <div className={styles.dueDate}>{getDueDateLabel(t, doc.due_date_for_action)}</div>
                  </div>
                  <ChevronIcon />
                </div>
                <div className={styles.progress}>
                  <div
                    className={styles.progressBar}
                    style={{ width: `${doc.acknowledged_percentage || 0}%` }} />
                </div>
                <div className={styles.stats}>
                  <div className={styles.stat}>
                    <div className={styles.statValueGreen}>{doc.acknowledged_count || 0}</div>
                    <div className={styles.statLabel}>{t('Acknowledged')}</div>
                  </div>
                  <div className={styles.stat}>
                    <div className={styles.statValue}>{doc.seen_only_count || 0}</div>
                    <div className={styles.statLabel}>{t('Seen only')}</div>
                  </div>
                  <div className={styles.stat}>
                    <div className={styles.statValue}>{doc.not_seen_count || 0}</div>
                    <div className={styles.statLabel}>{t('Not seen')}</div>
                  </div>
                  <div className={styles.stat}>
                    <div className={doc.overdue_count ? styles.statValueRed : styles.statValue}>{doc.overdue_count || 0}</div>
                    <div className={styles.statLabel}>{t('Overdue')}</div>
                  </div>
                </div>
                <div className={styles.footer}>
                  <div className={styles.badge}>
                    {t('{{percentage}}% acknowledged', { percentage: doc.acknowledged_percentage || 0 })}
                  </div>
                  <div className={styles.footerText}>
                    {
                      t('{{loaded}} employees acknowledged of {{total}}', {
                        loaded: doc.acknowledged_count || 0,
                        total: doc.total_assignees || 0,
                      })
                    }
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}

export default AcknowledgmentDocuments

